import React, { useState, useRef, useEffect, useContext } from 'react';
import { LoadingContext } from "react-router-loading";
import { Row } from 'antd';
import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { TokenVerificationLoggedin, /*ScreenView,*/ BlockAdmin } from "../../utils/tokenVerify";
// import Dropdown from 'react-bootstrap/Dropdown';
import configData from "../../config/config.json";
import { Table, Radio, Select, /*Switch,*/ Checkbox, Space, Col, Input, Button, Pagination, Tooltip } from 'antd';
import errorData from '../../assets/images/data-graph/error-data.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
// import mediaKitIcon2 from '../../assets/images/icons/export_download_icon.svg';
import FullLoader from "../../assets/images/full-page-loader.gif"
// import filterIcon from '../../assets/images/icons/filter.svg';
// import HoverCloseIcon from '../../assets/images/icons/hover_close.svg';
import { notifysuccess } from "../../utils/toast";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import { Link } from 'react-router-dom'
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
// import { /*CheckOutlined, CloseOutlined,*/ PlusOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import TableLoader from '../TableLoader';

const tagOptions = ["exhaustive", "top", "direct"];

const AdsTxtMobileOps = () => {
    const loadingContext = useContext(LoadingContext);
    const [/* checkRole */, setCheckRole] = useState("admin")
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)


    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)
            if ((checkRole !== "admin" && checkRole !== "u_admin")) {
                getData(tab)
            }

        }

        // setTimeout(() => {
        //     setPageLoad(false)
        // }, 500)
        loadingContext.done()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContext]);


    const [tab, setTab] = useState("live")
    function handleTabChange(event) {
        setTab(event.target.value)

        // let data = event.target.value
        // if (filter !== event.target.value) {
        //     setTabLoad(true)
        // }
        // setFilter(data)
        let tempPage = page
        tempPage.current = 1
        tempPage.total = 10
        setPage(tempPage)

        // setPage({
        //   current: 1,
        //   pageSize: 10,
        //   total: 10,
        // })
        setSearch("")
        setSearchText("")
        // setSort({
        //     name: "",
        //     type: ""
        // })
        // resetSorter()
        setInitialLoad(true)
        getData(event.target.value)

        // setApicall(!apiCall)
    }

    // eslint-disable-next-line no-unused-vars
    const resetSorter = () => {
        setTimeout(() => {
            document.querySelectorAll('th[aria-sort]').forEach(th => {
                th.removeAttribute('aria-sort');
            });

            document.querySelectorAll('span[aria-label="caret-up"]').forEach(span => {
                span.classList.remove('active');
            });

            document.querySelectorAll('span[aria-label="caret-down"]').forEach(span => {
                span.classList.remove('active');
            });

        }, 0);

    };

    const [uploadLoader, setUploadLoader] = useState(false)

    const VALID_TYPES = ["direct", "top", "exhaustive"];
    const VALID_PLATFORMS = ["website", "ctv", "mobile"];

    // const validateAdsTxtContent = (text) => {
    //     const lines = text.split(/\r?\n/).filter(l => l.trim());

    //     const errors = [];

    //     lines.forEach((line, index) => {
    //         const lineNumber = index + 1;

    //         // must split into exactly 3 parts
    //         const parts = line.split(";;");
    //         if (parts.length !== 3) {
    //             errors.push(`Line ${lineNumber}: Must contain exactly 3 parts separated by ';;'`);
    //             return;
    //         }

    //         const [type, platforms, content] = parts.map(p => p.trim());

    //         // 1️⃣ validate type
    //         if (!VALID_TYPES.includes(type)) {
    //             errors.push(
    //                 `Line ${lineNumber}: Invalid type "${type}". Allowed: ${VALID_TYPES.join(", ")}`
    //             );
    //         }

    //         // 2️⃣ validate platforms
    //         const platformList = platforms.split(",").map(p => p.trim());

    //         if (platformList.length === 0) {
    //             errors.push(`Line ${lineNumber}: At least one platform is required`);
    //         }

    //         const invalidPlatforms = platformList.filter(
    //             p => !VALID_PLATFORMS.includes(p)
    //         );

    //         if (invalidPlatforms.length > 0) {
    //             errors.push(
    //                 `Line ${lineNumber}: Invalid platform(s): ${invalidPlatforms.join(", ")}`
    //             );
    //         }

    //         // no duplicates
    //         if (new Set(platformList).size !== platformList.length) {
    //             errors.push(`Line ${lineNumber}: Duplicate platforms are not allowed`);
    //         }

    //         // 3️⃣ validate third part
    //         if (!content) {
    //             errors.push(`Line ${lineNumber}: Third section cannot be empty`);
    //         }
    //     });

    //     return errors;
    // };

    const validateAdsTxtContent = (text) => {
        const lines = text.split(/\r?\n/).filter(l => l.trim());
        const errors = [];
        const seenColumnNames = new Map();

        lines.forEach((line, index) => {
            const lineNumber = index + 1;

            // must split into exactly 6 parts
            const parts = line.split(";;");
            if (parts.length !== 6) {
                errors.push(
                    `Line ${lineNumber}: Must contain exactly 6 parts separated by ';;'`
                );
                return;
            }

            const [
                columnName,
                type,
                platforms,
                parentName,
                childName,
                content
            ] = parts.map(p => p.trim());

            // 1️⃣ validate columnName
            if (!columnName) {
                errors.push(`Line ${lineNumber}: Column name cannot be empty`);
            } else {
                // ✅ Case-insensitive duplicate check
                const normalizedName = columnName.toLowerCase();
                if (seenColumnNames.has(normalizedName)) {
                    const firstOccurrence = seenColumnNames.get(normalizedName);
                    errors.push(
                        `Line ${lineNumber}: Duplicate column name "${columnName}" — already used on line ${firstOccurrence}`
                    );
                } else {
                    seenColumnNames.set(normalizedName, lineNumber);
                }
            }

            // 2️⃣ validate type
            if (!VALID_TYPES.includes(type)) {
                errors.push(
                    `Line ${lineNumber}: Invalid type "${type}". Allowed: ${VALID_TYPES.join(", ")}`
                );
            }

            // 2️⃣ validate platforms
            const platformList = platforms.split(",").map(p => p.trim());

            if (platformList.length === 0) {
                errors.push(`Line ${lineNumber}: At least one platform is required`);
            }

            const invalidPlatforms = platformList.filter(
                p => !VALID_PLATFORMS.includes(p)
            );

            if (invalidPlatforms.length > 0) {
                errors.push(
                    `Line ${lineNumber}: Invalid platform(s): ${invalidPlatforms.join(", ")}`
                );
            }

            // no duplicate platforms
            if (new Set(platformList).size !== platformList.length) {
                errors.push(`Line ${lineNumber}: Duplicate platforms are not allowed`);
            }

            // 4️⃣ validate parentName
            if (!parentName) {
                errors.push(`Line ${lineNumber}: Parent name cannot be empty`);
            }

            // 5️⃣ validate childName (must be either parent or child)
            // if (!["parent", "child"].includes(childName.toLowerCase())) {
            //     errors.push(
            //         `Line ${lineNumber}: childName must be either "parent" or "child"`
            //     );
            // }

            if (!["parent", "child"].includes(childName)) {
                errors.push(
                    `Line ${lineNumber}: childName must be either "parent" or "child" (lowercase only)`
                );
            }

            // 6️⃣ validate content
            if (!content) {
                errors.push(`Line ${lineNumber}: Content cannot be empty`);
            }
        });

        return errors;
    };


    function onChangeMediakit(e) {
        const file = e.target.files[0];
        if (!file) return;

        const ext = file.name.split('.').pop().toLowerCase();
        if (!['xlsx', 'xls'].includes(ext) || file.size / (1024 * 1024) > 100) {
            notifyfailure("File should be in .xlsx or .xls format and less than 100 mb");
            const fileInput00 = document.getElementById("file004");
            fileInput00.value = "";
            return;
        }

        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

                const EXPECTED_HEADERS = [
                    'name', 'mapping_type', 'inventory_types', 'parent_name', 'hierarchy',
                    'ad_system_domain', 'publisher_account_id', 'relationship_type', 'certification_authority_id'
                ];

                const headerRow = (rows[0] || []).map(h => String(h || '').trim());
                const missingHeaders = EXPECTED_HEADERS.filter(h => !headerRow.includes(h));
                const extraHeaders = headerRow.filter(h => h && !EXPECTED_HEADERS.includes(h));
                const duplicateHeaders = [...new Set(headerRow.filter((h, i) => h && headerRow.indexOf(h) !== i))];

                if (missingHeaders.length > 0 || extraHeaders.length > 0 || duplicateHeaders.length > 0) {
                    let errorMsg = "Invalid file headers.";
                    if (missingHeaders.length > 0) errorMsg += ` Missing: ${missingHeaders.join(', ')}.`;
                    if (extraHeaders.length > 0) errorMsg += ` Unexpected: ${extraHeaders.join(', ')}.`;
                    if (duplicateHeaders.length > 0) errorMsg += ` Duplicate: ${duplicateHeaders.join(', ')}.`;
                    notifyfailure(errorMsg);
                    const fileInput00 = document.getElementById("file004");
                    fileInput00.value = "";
                    return;
                }

                const dataRows = (rows || []).slice(1).filter(row => row.some(cell => String(cell).trim()));

                if (dataRows.length === 0) {
                    notifyfailure("File is empty");
                    const fileInput00 = document.getElementById("file004");
                    fileInput00.value = "";
                    return;
                }

                // Convert Excel rows to the ;; format used by validation
                const lines = dataRows.map(row => {
                    const name = String(row[0] || '').trim();
                    const mappingType = String(row[1] || '').trim();
                    const inventoryTypes = String(row[2] || '').trim();
                    const parentName = String(row[3] || '').trim();
                    const hierarchy = String(row[4] || '').trim();
                    const adSystemDomain = String(row[5] || '').trim();
                    const publisherAccountId = String(row[6] || '').trim();
                    const relationshipType = String(row[7] || '').trim();
                    const certAuthorityId = String(row[8] || '').trim();

                    const contentParts = [adSystemDomain, publisherAccountId, relationshipType];
                    if (certAuthorityId) contentParts.push(certAuthorityId);
                    const content = contentParts.join(', ');

                    return `${name};;${mappingType};;${inventoryTypes};;${parentName};;${hierarchy};;${content}`;
                });

                const text = lines.join('\n');
                const validationErrors = validateAdsTxtContent(text);

                if (validationErrors.length > 0) {
                    const duplicateErrors = validationErrors.filter(err =>
                        err.toLowerCase().includes("duplicate column name")
                    );
                    const otherErrors = validationErrors.filter(err =>
                        !err.toLowerCase().includes("duplicate column name")
                    );

                    const addColumnInfo = (errMsg) => {
                        const colMap = [
                            { pattern: /Column name cannot be empty/, col: 'A', colName: 'name' },
                            { pattern: /Invalid type/, col: 'B', colName: 'mapping_type' },
                            { pattern: /platform is required|Invalid platform|Duplicate platform/i, col: 'C', colName: 'inventory_types' },
                            { pattern: /Parent name cannot be empty/, col: 'D', colName: 'parent_name' },
                            { pattern: /childName must be/, col: 'E', colName: 'hierarchy' },
                            { pattern: /Content cannot be empty/, col: 'F–I', colName: 'ad_system_domain / publisher_account_id / relationship_type / certification_authority_id' },
                        ];
                        for (const { pattern, col, colName } of colMap) {
                            if (pattern.test(errMsg)) {
                                return `${errMsg} [Column ${col}: ${colName}]`;
                            }
                        }
                        return errMsg;
                    };

                    if (duplicateErrors.length > 0) {
                        notifyfailure(`Duplicate column name found. Column name must be unique. [Column A: name]`);
                    }

                    if (otherErrors.length > 0) {
                        const firstError = otherErrors[0].replace(
                            /^Line (\d+):/,
                            (_, n) => `Row ${parseInt(n) + 1}:`
                        );
                        notifyfailure(addColumnInfo(firstError));
                    }

                    const fileInput00 = document.getElementById("file004");
                    fileInput00.value = "";
                    return;
                }

                // ✅ proceed with upload
                const formData = new FormData();
                formData.append("adsTxt", file);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    let token = Cookies.get("token_xapads_ssp");

                    const fileInput00 = document.getElementById("file004");
                    fileInput00.value = "";
                    setUploadLoader(true);
                    setLoading(true);

                    axios
                        .post(configData.SERVER_URL + `app-ads/uploadAdsTxt`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setUploadLoader(false);
                            setLoading(false);

                            if (response.data.data.length > 0) {
                                setDataSource(
                                    response.data.data.map(item => ({
                                        key: item._id,
                                        status: item.status,
                                        tag: item.tag,
                                        name: item.name,
                                        parentName: item.parentName,
                                        type: item.lineType,
                                        lines: item.adlines,
                                        platform: item.platform,
                                        isNewRow: false,
                                        isEditing: false,
                                        originalRow: null,
                                        errors: {}
                                    }))
                                );
                            }
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setUploadLoader(false);
                            setLoading(false);
                        });
                }
            } catch (err) {
                notifyfailure("Failed to read the Excel file. Please check the file format.");
                const fileInput00 = document.getElementById("file004");
                fileInput00.value = "";
            }
        };

        reader.readAsArrayBuffer(file);
    }


    const getData = (tabData) => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");


            if (tabData === "live") {

                axios
                    .get(configData.SERVER_URL + `app-ads/adstxtList`, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                    .then((response) => {

                        if (response.data.data?.length > 0) {
                            setDataSource(
                                response.data.data?.map(item => ({
                                    key: item._id,
                                    status: item.status,
                                    tag: item.tag,
                                    name: item.name,
                                    parentName: item.parentName,
                                    type: item.lineType,
                                    lines: item.adlines,
                                    platform: item.platform,
                                    isNewRow: false,
                                    isEditing: false,
                                    originalRow: null,
                                    errors: {}
                                }))
                            )
                        }

                        setLoading(false)
                        setInitialLoad(false)
                    })
                    .catch((error) => {
                        setDataSource([])
                        setLoading(false)
                        setInitialLoad(false)
                    });

            }
            else {

                //   .post(configData.SERVER_URL + `app-ads/adstxtHistory?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                axios
                    .post(configData.SERVER_URL + `app-ads/adstxtHistory`,
                        {

                            "page": page.current,
                            "limit": page.pageSize

                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                        })
                    .then((response) => {
                        setDataSourceHistory(response.data.data)
                        if (response.data.data.length > 0) {
                            let tempPage = { ...page }
                            tempPage.total = response.data.pagination?.totalRecords

                            setPage(tempPage)

                        }

                        setLoading(false)
                        setInitialLoad(false)
                    })
                    .catch((error) => {
                        setDataSourceHistory([])
                        setLoading(false)
                        setInitialLoad(false)
                    });
            }
        }
    }


    // function handleTabChange(event) {
    //     let data = event.target.value
    //     if (filter !== event.target.value) {
    //         setTabLoad(true)
    //     }
    //     setFilter(data)
    //     let tempPage = page
    //     tempPage.current = 1
    //     tempPage.total = 10
    //     setPage(tempPage)

    //     // setPage({
    //     //   current: 1,
    //     //   pageSize: 10,
    //     //   total: 10,
    //     // })
    //     setSearch("")
    //     setSort({
    //         name: "",
    //         type: ""
    //     })
    //     resetSorter()
    //     setApicall(!apiCall)
    // }



    ////////////////---------------------------------------live tab --------------------------------------------------/////////////////////////////////////////////////////

    const handleDownloadSampleFile = async () => {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL + `app-ads/sampleAdstxt`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    saveAs(blob, "Sample-Ads.xlsx");
                    notifysuccess("File downloaded successfully.");
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure("Unable to download the file.");
                        }
                    } else {
                        notifycatch();
                    }
                });
        }
    };



    const columns = [
        {
            title: "Status",
            dataIndex: "status",
            fixed: 'left',
            width: 100,
            sorter: (a, b) => {
                // 🚫 ignore sorting for new rows
                if (a.isNewRow || b.isNewRow) return 0;

                // ✅ normal sorting for saved rows
                return a.status.localeCompare(b.status);
            },
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (value, record) => (
                record.isNewRow ?
                    <></>
                    :
                    <div
                        className={`vertical_alignment_text case_select_tag ${value === "disabled" ? "--rejected_cascader" : ""
                            }`}
                    >
                        <Select
                            value={value}                       // ✅ controlled
                            dropdownMatchSelectWidth={false}
                            popupClassName='ant_select_dropdown_remove_icon'
                            suffixIcon={null}
                            onChange={(v) =>
                                handleChangeStatus(record.key, "status", v) // ✅ correct handler
                            }
                            options={[
                                { value: 'enabled', label: 'Enabled' },
                                { value: 'disabled', label: 'Disabled' },
                            ]}
                        />
                    </div>

            )
        },
        {
            title: "Tag",
            width: 90,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            dataIndex: "tag",
            sorter: (a, b) => {
                // 🚫 ignore sorting for new rows
                if (a.isNewRow || b.isNewRow) return 0;

                // ✅ normal sorting for saved rows
                return a.tag.localeCompare(b.tag);
            },
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (value, record) => (
                // --direct --exhaustive --top
                record.isNewRow ?
                    <div className={value === "direct" ? 'case_select_tag --diff_case_select_tag --padding_select_cls  --direct' : value === "exhaustive" ? 'case_select_tag --diff_case_select_tag --padding_select_cls --exhaustive' : 'case_select_tag --diff_case_select_tag --padding_select_cls --top'}>
                        <Select
                            size="small"
                            dropdownMatchSelectWidth={false}
                            // open={true}
                            popupClassName='ant_select_dropdown_remove_icon'
                            suffixIcon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 6L8 10L12 6" stroke="#475467" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                            value={value}
                            // style={{ width: 120 }}
                            onChange={v => handleChange(record.key, "tag", v)}
                        >
                            {tagOptions.map(opt => (
                                <Select.Option key={opt} value={opt}>
                                    {opt.charAt(0).toUpperCase() + opt.slice(1)}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    :
                    <div className={value === "direct" ? 'vertical_alignment_text case_select_tag --diff_case_select_tag --padding_select_cls  --direct' : value === "exhaustive" ? 'vertical_alignment_text case_select_tag --diff_case_select_tag --padding_select_cls --exhaustive' : 'vertical_alignment_text case_select_tag --diff_case_select_tag --padding_select_cls --top'}>
                        <Select
                            size="small"
                            dropdownMatchSelectWidth={false}
                            // open={true}
                            popupClassName='ant_select_dropdown_remove_icon'
                            suffixIcon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 6L8 10L12 6" stroke="#475467" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                            value={value}
                            // style={{ width: 120 }}
                            onChange={v => handleChangeStatus(record.key, "tag", v)}
                        >
                            {tagOptions.map(opt => (
                                <Select.Option key={opt} value={opt}>
                                    {opt.charAt(0).toUpperCase() + opt.slice(1)}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
            )
        },
        {
            title: "Name",
            width: 200,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            dataIndex: "name",
            render: (value, record) =>
                record.isNewRow ? (
                    <Input
                        placeholder="Enter Name"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e =>
                            handleChange(record.key, "name", e.target.value)
                        }
                    />
                ) : (
                    <span className="lines_readonly">
                        {value?.length >= 25 ?
                            <Tooltip title={value}>< >{value?.slice(0, 25)}...</></Tooltip> :
                            < >{value}</>}
                    </span>
                )
        },
        {
            title: "Parent Name",
            width: 200,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            dataIndex: "parentName",
            render: (value, record) =>
                record.isNewRow ? (
                    <Input
                        placeholder="Enter Parent Name"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e =>
                            handleChange(record.key, "parentName", e.target.value)
                        }
                    />
                ) : (
                    <span className="lines_readonly">
                        {value?.length >= 25 ?
                            <Tooltip title={value}>< >{value?.slice(0, 25)}...</></Tooltip> :
                            < >{value}</>}
                    </span>
                )
        },
        {
            title: "Type",
            width: 100,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            dataIndex: "type",
            render: (value, record) =>
                record.isNewRow ? (

                    <Select
                        className="modal_select_tag_cls"
                        style={{ width: "100%" }}
                        options={[
                            { label: "Parent", value: "parent" },
                            { label: "Child", value: "child" }
                        ]}
                        value={value}
                        onChange={v =>
                            handleChange(record.key, "type", v)
                        }
                        suffixIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M4 6L8 10L12 6" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        }


                    ></Select>
                ) : (
                    <>
                        {(value === "" || value === null || value === undefined) ?
                            <></>
                            :
                            <span className="lines_readonly">
                                <small className='tag_bg_text'> {value === "parent" ? "Parent" : value === "child" ? "Child" : ""}</small>
                            </span>
                        }
                    </>

                )
        },
        {
            title: "Lines",
            width: 600,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            dataIndex: "lines",
            render: (value, record) =>
                record.isNewRow ? (
                    <Input
                        placeholder="Enter here"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e =>
                            handleChange(record.key, "lines", e.target.value)
                        }
                    />
                ) : (
                    <span className="lines_readonly">
                        {value}
                    </span>
                )
        },
        {
            title: "Platform",
            dataIndex: "platform",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            sorter: (a, b) => {
                // 🚫 ignore sorting for new rows
                if (a.isNewRow || b.isNewRow) return 0;

                const lenA = a.platform?.length || 0;
                const lenB = b.platform?.length || 0;

                return lenA - lenB; // ⬆️ ascending by count
            },
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (value, record) => (
                // record.isNewRow ?
                <div className='new_design_ant_checkbox'>
                    <Checkbox.Group
                        value={value}
                        className="form_checkbox equal_space"
                        onChange={v => handleChange(record.key, "platform", v)}
                    >
                        <Space>
                            <Checkbox className="checkbox_btn w-auto" value="ctv">CTV</Checkbox>
                            <Checkbox className="checkbox_btn w-auto" value="mobile">Mobile</Checkbox>
                            <Checkbox className="checkbox_btn w-auto" value="website"> Website</Checkbox>
                        </Space>
                    </Checkbox.Group>

                    {/* {(record.isNewRow || record.isEditing) &&
                        record.errors?.platform && (
                            <div className="field_error_text" style={{ color: "red" }}>
                                {record.errors.platform}
                            </div>
                        )} */}
                </div>
                // :
                // <div className='new_design_ant_checkbox'>
                //     <Checkbox.Group
                //         value={value}
                //         className="form_checkbox equal_space"
                //         onChange={v => handleChangeStatus(record.key, "platform", v)}
                //     >
                //         <Space>
                //             <Checkbox className="checkbox_btn w-auto" value="ctv">CTV</Checkbox>
                //             <Checkbox className="checkbox_btn w-auto" value="mobile">Mobile</Checkbox>
                //             <Checkbox className="checkbox_btn w-auto" value="website"> Website</Checkbox>
                //         </Space>
                //     </Checkbox.Group>

                //     {/* {(record.isNewRow || record.isEditing) &&
                //     record.errors?.platform && (
                //         <div className="field_error_text" style={{ color: "red" }}>
                //             {record.errors.platform}
                //         </div>
                //     )} */}
                // </div>
            )
        },
        {
            title: "",
            render: (_, record) =>
                record.isNewRow || record.isEditing ? (
                    <Space>
                        <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                            <Tooltip title="Save">
                                <div
                                    className={`div_of_icon --save_icon_div cursor_pointer ${!isRowValid(record) ? "disabled" : ""
                                        }`}

                                    style={{ opacity: !isRowValid(record) ? "0.5" : "1" }}
                                    onClick={() => {
                                        if (!isRowValid(record)) return;   // ⛔ HARD BLOCK


                                        if (record.isNewRow) {
                                            handleSave(record.key);
                                        }
                                        else {
                                            handleChangeStatus(record.key, "platform", record.platform)

                                        }

                                    }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </Tooltip>
                            <Tooltip title="Discard">
                                <div className='div_of_icon --cancel_icon_div cursor_pointer' onClick={() => handleCancel(record.key)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </Tooltip>
                        </div>
                    </Space>
                ) : null
        }
    ];


    //sample object -------------------------------------------

    // {
    //     key: "1",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER",
    //     platform: ["ctv"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "2",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "3",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "4",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "5",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "6",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "7",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "8",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "9",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "10",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "11",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // },
    // {
    //     key: "12",
    //     status: "enabled",
    //     tag: "exhaustive",
    //     lines: "pubmatic.com, 137711, RESELLER, 5d62403b186f2ace",
    //     platform: ["ctv", "mobile", "website"],
    //     isNewRow: false,
    //     isEditing: false,
    //     originalRow: null,
    //     errors: {}
    // }


    const [dataSource, setDataSource] = useState([]);

    const capitalize = str =>
        typeof str === "string"
            ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
            : str;

    // eslint-disable-next-line no-unused-vars
    const formatPlatform = p => {
        if (!p) return p;
        if (p.toLowerCase() === "ctv") return "CTV";
        return capitalize(p);
    };

    // const handleExport = () => {
    //     // export only saved rows
    //     const rowsToExport = dataSource.filter(
    //         row => !row.isNewRow && !row.isEditing
    //     );

    //     if (!rowsToExport.length) {
    //         notifyfailure("No data available to export");
    //         return;
    //     }

    //     // convert table rows → export rows
    //     const exportData = rowsToExport.map(row => ({
    //         Status: capitalize(row.status),
    //         Tag: capitalize(row.tag),
    //         Lines: row.lines,
    //         Platform: row.platform
    //             ?.map(formatPlatform)
    //             .join(","),
    //     }));

    //     // create worksheet
    //     const worksheet = XLSX.utils.json_to_sheet(exportData);

    //     // create workbook
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "ads_txt");

    //     // export file
    //     const excelBuffer = XLSX.write(workbook, {
    //         bookType: "xlsx",
    //         type: "array"
    //     });

    //     const file = new Blob([excelBuffer], {
    //         type:
    //             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    //     });

    //     saveAs(file, `ads_txt_export_${Date.now()}.xlsx`);
    // };

    const handleExport = () => {
        const rowsToExport = dataSource.filter(
            row => !row.isNewRow && !row.isEditing
        );

        if (!rowsToExport.length) {
            notifyfailure("No data available to export");
            return;
        }

        const exportData = rowsToExport.map(row => {
            const contentParts = (row.lines || '').split(/,\s*/);
            return {
                name: row.name,
                mapping_type: row.tag,
                inventory_types: (row.platform || []).join(','),
                parent_name: row.parentName,
                hierarchy: row.type,
                ad_system_domain: contentParts[0] || '',
                publisher_account_id: contentParts[1] || '',
                relationship_type: contentParts[2] || '',
                certification_authority_id: contentParts[3] || '',
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ads_txt");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const file = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(file, `ads_txt_export_${Date.now()}.xlsx`);
    };

    const tableSummary = React.useMemo(() => {
        const summary = {
            total: 0,
            tagCount: {
                exhaustive: 0,
                top: 0,
                direct: 0
            },
            enabled: 0,
            disabled: 0
        };

        dataSource?.forEach(row => {
            // count only saved rows (optional but recommended)
            if (row.isNewRow) return;

            summary.total += 1;

            // tag count
            if (summary.tagCount[row.tag] !== undefined) {
                summary.tagCount[row.tag] += 1;
            }

            // status count
            if (row.status === true || row.status === "enabled") {
                summary.enabled += 1;
            } else {
                summary.disabled += 1;
            }
        });

        return summary;
    }, [dataSource]);

    const [searchText, setSearchText] = useState("");
    const tableWrapperRef = useRef(null);

    // const filteredDataSource = React.useMemo(() => {
    //     if (!searchText.trim()) return dataSource;

    //     const query = searchText.toLowerCase();

    //     return dataSource.filter(row => {
    //         return (
    //             row.status?.toLowerCase().includes(query) ||
    //             row.tag?.toLowerCase().includes(query) ||
    //             row.lines?.toLowerCase().includes(query) ||
    //             row.platform?.join(" ").toLowerCase().includes(query)
    //         );
    //     });
    // }, [dataSource, searchText]);

    const filteredDataSource = React.useMemo(() => {
        const query = searchText.trim().toLowerCase();

        // 1️⃣ apply search (but NEVER exclude new/editing row)
        const searched = !query
            ? dataSource
            : dataSource.filter(row => {
                if (row.isNewRow) return true; // 🔒 keep editing row visible

                return (
                    row.status?.toLowerCase().includes(query) ||
                    row.tag?.toLowerCase().includes(query) ||
                    row.name?.toLowerCase().includes(query) ||
                    row.parentName?.toLowerCase().includes(query) ||
                    row.type?.toLowerCase().includes(query) ||
                    row.lines?.toLowerCase().includes(query) ||
                    row.platform?.join(" ").toLowerCase().includes(query)
                );
            });

        // 2️⃣ force editing rows to the bottom (ignore sorting)
        const editingRows = searched.filter(
            row => row.isNewRow === true
        );

        const normalRows = searched.filter(
            row => row.isNewRow !== true
        );

        return [...normalRows, ...editingRows]; // ✅ guaranteed last
    }, [dataSource, searchText]);

    const hasNewRow = dataSource.some(row => row.isNewRow);
    const handleAddMore = () => {
        if (hasNewRow) return;

        setDataSource(prev => [
            ...prev,
            {
                key: Date.now(),
                status: "enabled",
                tag: "exhaustive",
                name: "",
                parentName: "",
                type: "parent", // default
                lines: "",
                platform: [],
                isNewRow: true,
                isEditing: true,
                originalRow: null,
                errors: {
                    name: "Name is required",
                    parentName: "Parent name is required",
                    lines: "Lines is required",
                    platform: "Select at least one platform"
                }
            }
        ]);

        setTimeout(() => {
            const tableBody =
                tableWrapperRef.current?.querySelector(".ant-table-body");

            if (tableBody) {
                tableBody.scrollTo({
                    top: tableBody.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 0);
    };

    // const isRowValid = row => {
    //     return row.lines?.trim() && row.platform?.length > 0;
    // };

    const isRowValid = row =>
        !row.errors || Object.keys(row.errors).length === 0;

    const validateRow = row => {
        const errors = {};

        if (!row.name?.trim()) {
            errors.name = "Name is required";
        }

        if (!row.parentName?.trim()) {
            errors.parentName = "Parent Name is required";
        }

        if (!row.lines?.trim()) {
            errors.lines = "Lines is required";
        }

        if (!row.platform || row.platform.length === 0) {
            errors.platform = "Select at least one platform";
        }

        return errors;
    };

    // const handleSave = key => {
    //     setDataSource(prev =>
    //         prev.map(row => {
    //             if (row.key !== key) return row;

    //             if (!isRowValid(row)) {
    //                 notifyfailure("Lines is required and at least one platform must be selected");
    //                 return row;
    //             }

    //             return {
    //                 ...row,
    //                 isNewRow: false,
    //                 isEditing: false,
    //                 originalRow: null
    //             };
    //         })
    //     );
    // };

    const handleSave = async key => {
        const rowToSave = dataSource.find(r => r.key === key);
        if (!rowToSave) return;

        // 1️⃣ Validation
        if (!isRowValid(rowToSave)) {
            notifyfailure("Name,Parent Name and Lines are required and at least one platform must be selected");
            return;
        }

        // ✅ 2️⃣ Case-insensitive unique name check against existing table rows
        const isDuplicateName = dataSource.some(
            row =>
                row.key !== key &&           // exclude current row
                !row.isNewRow &&             // only check saved rows
                row.name?.trim().toLowerCase() === rowToSave.name?.trim().toLowerCase()
        );

        if (isDuplicateName) {
            notifyfailure(`Name "${rowToSave.name}" already exists. Please use a unique name.`)
            return;
        }

        // 2️⃣ Snapshot for rollback (only once)
        // if (!rowToSave.originalRow) {
        //     setDataSource(prev =>
        //         prev.map(row =>
        //             row.key === key
        //                 ? { ...row, originalRow: { ...row } }
        //                 : row
        //         )
        //     );
        // }


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {


            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `app-ads/manualEntry`,
                    {
                        "name": rowToSave.name,
                        "parentName": rowToSave.parentName,
                        "lineType": rowToSave.type,
                        "line": rowToSave.lines,
                        "tag": rowToSave.tag,
                        "platform": rowToSave.platform
                    }
                    , {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        }
                    }
                )
                .then((response) => {
                    notifysuccess(response.data.message);


                    const newRow = {
                        key: response.data.data._id,
                        status: response.data.data.status,
                        name: response.data.data.name,
                        parentName: response.data.data.parentName,
                        type: response.data.data.lineType,
                        tag: response.data.data.tag,
                        lines: response.data.data.adlines,
                        platform: response.data.data.platform,
                        isNewRow: false,
                        isEditing: false,
                        originalRow: null,
                        errors: {}
                    };

                    // 4️⃣ replace temp row OR append
                    setDataSource(prev =>
                        prev
                            .filter(row => row.key !== key) // remove temp row
                            .concat(newRow)
                    );

                    setLoading(false)

                })
                .catch((error) => {
                    if (error?.response) {
                        if (error.response.data.message?.length !== 0) {
                            notifyfailure(error.response.data.message);
                        }
                    } else {
                        notifycatch();
                    }
                    setLoading(false)

                    setDataSource(prev =>
                        prev.map(row =>
                            row.key === key && row.originalRow
                                ? { ...row.originalRow, isEditing: false }
                                : row
                        )
                    );


                });
        }



    };


    const handleCancel = key => {
        setDataSource(prev =>
            prev.map(row => {
                if (row.key !== key) return row;

                if (row.isNewRow) return null;

                return {
                    ...row.originalRow,
                    isEditing: false,
                    originalRow: null,
                    errors: {}
                };
            }).filter(Boolean)
        );
    };

    const isSameArray = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        return [...a].sort().every((v, i) => v === [...b].sort()[i]);
    };

    const hasRowChanged = (row) => {
        if (!row.originalRow) return false;

        return (
            row.status !== row.originalRow.status ||
            row.tag !== row.originalRow.tag ||
            row.lines !== row.originalRow.lines ||
            !isSameArray(row.platform, row.originalRow.platform)
        );
    };

    const handleChange = (key, field, value) => {
        setDataSource(prev =>
            prev.map(row => {
                if (row.key !== key) return row;

                const baseOriginal =
                    row.originalRow ??
                    (!row.isEditing && !row.isNewRow ? { ...row } : null);

                const updatedRow = {
                    ...row,
                    [field]: value,
                    originalRow: baseOriginal,
                };

                const changed = hasRowChanged({
                    ...updatedRow,
                    originalRow: baseOriginal,
                });

                return {
                    ...updatedRow,
                    isEditing: row.isNewRow ? true : changed, // ✅ key line
                    errors: validateRow(updatedRow),
                };
            })
        );
    };



    // const handleChangeStatus = (key, field, value) => {

    //     setDataSource(prev =>
    //         prev.map(row => {
    //             if (row.key !== key) return row;

    //             const updatedRow = {
    //                 ...row,
    //                 [field]: value,
    //                 isEditing: row.isNewRow ? true : row.isEditing,
    //                 // originalRow:
    //                 //     !row.isEditing && !row.isNewRow
    //                 //         ? { ...row }
    //                 //         : row.originalRow
    //                 // originalRow:
    //                 //     { ...row }
    //             };

    //             return {
    //                 ...updatedRow,
    //                 errors: validateRow(updatedRow)
    //             };
    //         })
    //     );
    // };

    const handleChangeStatus = async (key, field, value) => {
        // eslint-disable-next-line no-unused-vars
        let previousRow = null;

        // 1. Optimistic update
        setDataSource(prev =>
            prev.map(row => {
                if (row.key !== key) return row;

                // store original row only once
                if (!row.originalRow) {
                    previousRow = { ...row };
                }

                const updatedRow = {
                    ...row,
                    [field]: value,
                    isEditing: row.isNewRow ? true : row.isEditing,
                    originalRow: row.originalRow ?? { ...row }
                };

                return {
                    ...updatedRow,
                    errors: validateRow(updatedRow)
                };
            })
        );

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            // let payload;
            // if (key === "platform") {
            //     payload = {
            //         "docId": key,
            //         "platform": value
            //     }
            // }

            // if (key === "status") {
            //     payload = {
            //         "docId": key,
            //         "status": value
            //     }
            // }

            // if (key === "tag") {
            //     payload = {
            //         "docId": key,
            //         "tag": value
            //     }
            // }

            const payload = {
                docId: key,
                [field]: value
            };

            setLoading(true)

            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `app-ads/editAdstxt`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    }
                }
                )
                .then((response) => {
                    notifysuccess(response.data.message);


                    setDataSource(prev =>
                        prev.map(row =>
                            row.key === key
                                ? { ...row, originalRow: null, isEditing: false }
                                : row
                        )
                    );
                    setLoading(false)

                })
                .catch((error) => {
                    if (error?.response) {
                        if (error.response.data.message?.length !== 0) {
                            notifyfailure(error.response.data.message);
                        }
                    } else {
                        notifycatch();
                    }
                    setLoading(false)

                    setDataSource(prev =>
                        prev.map(row =>
                            row.key === key && row.originalRow
                                ? { ...row.originalRow }
                                : row
                        )
                    );


                });
        }



        // // 2. API call
        // try {
        //     const res = await api.updateStatus({ key, field, value });

        //     if (!res.data.status) {
        //         throw new Error("API failed");
        //     }

        //     // 3. Success → clear backup
        //     setDataSource(prev =>
        //         prev.map(row =>
        //             row.key === key
        //                 ? { ...row, originalRow: null }
        //                 : row
        //         )
        //     );

        // } catch (error) {
        //     // 4. Rollback on failure
        //     setDataSource(prev =>
        //         prev.map(row =>
        //             row.key === key && row.originalRow
        //                 ? { ...row.originalRow }
        //                 : row
        //         )
        //     );
        // }
    };


    //---------------------------------------------------------------history-----------------------------------------------------------------------------
    // const renderAuditValue = (values, record) => {
    //     if (!values || values.length === 0) return null;

    //     // TEXT (bullets)
    //     if (record.valueType === "text") {
    //         return (
    //             <ul className="audit-text">
    //                 {values.map((v, i) => (
    //                     <li key={i}>{v}</li>
    //                 ))}
    //             </ul>
    //         );
    //     }

    //     // STATUS
    //     if (record.valueType === "status") {
    //         return (
    //             <span className={`audit-status ${values[0].toLowerCase()}`}>
    //                 {values[0]}
    //             </span>
    //         );
    //     }

    //     // PLATFORM
    //     if (record.valueType === "platform") {
    //         return (
    //             <div className="audit-platform">
    //                 {values.map((v, i) => (
    //                     <span key={i}>{v}</span>
    //                 ))}
    //             </div>
    //         );
    //     }

    //     return null;
    // };

    const columnsHistory = [
        {
            title: "Timestamp",
            dataIndex: "timestamp",
            key: "timestamp",
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            fixed: 'left',
            onCell: () => ({
                className: "border-end-0",
            }),
            width: 180,
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            fixed: 'left',
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            onCell: () => ({
                className: "border-end-0",
            }),
            width: 200,
            render: (text, record) => (
                <>
                    {record.metric === "ads.txt" ?
                        <>
                            <div className='file_name_text'>{record.line}</div>
                        </>
                        :
                        <>
                            <div className='file_name_text'>{record.metric === "status" ? "Status Change" : record.metric === "tag" ? "Tag Change" : record.metric === "platform" ? "Platform Change" : ""}</div>
                            {record.line && (
                                record.line.length > 50 ? (
                                    <Tooltip title={record.line}>
                                        <div
                                            style={{
                                                color: "#475467",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {record.line.slice(0, 50)}…
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <div style={{ color: "#475467" }}>
                                        {record.line}
                                    </div>
                                )
                            )}

                        </>

                    }

                </>
            ),
        },
        {
            title: "Updated by",
            dataIndex: "updatedBy",
            key: "updatedBy",
            fixed: 'left',
            width: 200,
        },
        {
            title: "Old Value",
            dataIndex: "oldValue",
            key: "oldValue",
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            onCell: () => ({
                className: "border-end-0",
            }),
            // render: renderAuditValue,
            render: (text, record) => (
                <>
                    {record.metric === "status" ?
                        <>
                            <span className={`audit-status ${record.oldValue[0]?.toLowerCase()}`}>
                                {record.oldValue[0]?.charAt(0).toUpperCase() + record.oldValue[0]?.slice(1)}
                            </span>
                        </>
                        :
                        record.metric === "tag" ?
                            <>
                                {/* <span className={`audit-status ${record.oldValue?.toLowerCase()}`}>
                                    {record.oldValue}
                                </span> */}

                                <div className={record.oldValue[0] === "direct" ? 'case_select_tag --diff_case_select_tag  --direct' : record.oldValue[0] === "exhaustive" ? 'case_select_tag --diff_case_select_tag --exhaustive' : 'case_select_tag --diff_case_select_tag --top'}
                                    style={{ pointerEvents: "none" }}
                                >
                                    <Select
                                        size="small"
                                        dropdownMatchSelectWidth={false}
                                        // open={true}
                                        popupClassName='ant_select_dropdown_remove_icon'
                                        suffixIcon={
                                            // <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            //     <path d="M4 6L8 10L12 6" stroke="#475467" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                            // </svg>
                                            null
                                        }
                                        value={record.oldValue[0]}
                                    >
                                        {tagOptions.map(opt => (
                                            <Select.Option key={opt} value={opt}>
                                                {opt.charAt(0).toUpperCase() + opt.slice(1)}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </>
                            :
                            record.metric === "platform" ?
                                <div className="audit-platform">
                                    {record.oldValue.map((v, i) => (
                                        <span key={i}>{v === "website" ? "Website" : v === "ctv" ? "CTV" : "Mobile"}</span>
                                    ))}
                                </div>
                                :
                                <>
                                    <ul className="audit-text">
                                        {record.oldValue.map((v, i) => (
                                            <li key={i}>
                                                {v.length > 70 ? (
                                                    <Tooltip title={v}>
                                                        <span style={{ cursor: "pointer" }}>
                                                            {v.slice(0, 70)}…
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    v
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </>

                    }

                </>
            ),
        },
        {
            title: "New Value",
            dataIndex: "newValue",
            key: "newValue",
            onCell: () => ({
                className: "custom_td_bg",
            }),
            render: (text, record) => (
                <>
                    {record.metric === "status" ?
                        <>
                            <span className={`audit-status ${record.newValue[0]?.toLowerCase()}`}>
                                {record.newValue[0]?.charAt(0).toUpperCase() + record.newValue[0]?.slice(1)}
                            </span>
                        </>
                        :
                        record.metric === "tag" ?
                            <>
                                {/* <span className={`audit-status ${record.newValue?.toLowerCase()}`}>
                                    {record.newValue}
                                </span> */}
                                <div className={record.newValue[0] === "direct" ? 'case_select_tag --diff_case_select_tag  --direct' : record.newValue[0] === "exhaustive" ? 'case_select_tag --diff_case_select_tag --exhaustive' : 'case_select_tag --diff_case_select_tag --top'}
                                    style={{ pointerEvents: "none" }}
                                >
                                    <Select
                                        size="small"
                                        dropdownMatchSelectWidth={false}
                                        // open={true}
                                        popupClassName='ant_select_dropdown_remove_icon'
                                        suffixIcon={
                                            // <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            //     <path d="M4 6L8 10L12 6" stroke="#475467" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                            // </svg>
                                            null
                                        }
                                        value={record.newValue[0]}
                                    >
                                        {tagOptions.map(opt => (
                                            <Select.Option key={opt} value={opt}>
                                                {opt.charAt(0).toUpperCase() + opt.slice(1)}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </>
                            :
                            record.metric === "platform" ?
                                <div className="audit-platform">
                                    {record.newValue?.map((v, i) => (
                                        <span key={i}>{v === "website" ? "Website" : v === "ctv" ? "CTV" : "Mobile"}</span>
                                    ))}
                                </div>
                                :
                                <>
                                    <ul className="audit-text">
                                        {record.newValue.map((v, i) => (
                                            <li key={i}>
                                                {v.length > 70 ? (
                                                    <Tooltip title={v}>
                                                        <span style={{ cursor: "pointer" }}>
                                                            {v.slice(0, 70)}…
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    v
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </>

                    }

                </>
            ),
        },
    ];

    //sample data object ------------------------------------------------------------------------
    // [
    //     {
    //         "timestamp": "2026-01-19T06:37:08.198Z",
    //         "line": "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //         "metric": "platform",
    //         "oldValue": [
    //             "website"
    //         ],
    //         "newValue": [
    //             "website",
    //             "ctv",
    //             "mobile"
    //         ],
    //         "updatedBy": "ayush@xapads.com"
    //     },
    //     {
    //         "timestamp": "2026-01-19T06:37:08.198Z",
    //         "line": "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //         "metric": "status",
    //         "oldValue": "enabled",
    //         "newValue": "disabled",
    //         "updatedBy": "ayush@xapads.com"
    //     },
    //     {
    //         "timestamp": "2026-01-19T06:37:08.198Z",
    //         "line": "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //         "metric": "tag",
    //         "oldValue": "exhaustive",
    //         "newValue": "top",
    //         "updatedBy": "ayush@xapads.com"
    //     },
    //     {
    //         "timestamp": "2026-01-19T06:37:08.198Z",
    //         "line": "Added new line",
    //         "metric": "ads.txt",
    //         "oldValue": [
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0"
    //         ],
    //         "newValue": [
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0"
    //         ],
    //         "updatedBy": "ayush@xapads.com"
    //     },
    //     {
    //         "timestamp": "2026-01-19T06:37:08.198Z",
    //         "line": "Added new file",
    //         "metric": "ads.txt",
    //         "oldValue": [
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //         ],
    //         "newValue": [
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //             "pubmatic.com, pub-3990748024667386, DIRECT, f08c47fec0942fa0",
    //         ],
    //         "updatedBy": "ayush@xapads.com"
    //     }


    // ]

    const [dataSourceHistory, setDataSourceHistory] = useState([]);


    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [/* sort */, setSort] = useState({
        name: "",
        type: ""
    });
    const [search, setSearch] = useState("")
    const [apiCall, setApicall] = useState(false)

    useEffect(() => {
        if (!initialLoad) {
            getData(tab)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }

        setPage(tempPage);
        setApicall(!apiCall)
    };


    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const locale = {
        emptyText:
            <>{searchText?.trim()?.length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        {/* <img src={errorData} className='' alt="" /> */}
                        <div className='float_text_div'>
                            {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                   <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                        </div>
                    </div>
                </div>
                :
                searchText?.trim()?.length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>
                                {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                    <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                {/* <img src={errorData} className='' alt="" /> */}
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                      <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                      <p className='no_data_para'>There are no records to show you right <br /> now.</p> */}
                                </div>
                            </div>
                        </div>
            }
            </>

    };

    const localeHistory = {
        emptyText:
            <>{search?.trim()?.length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        {/* <img src={errorData} className='' alt="" /> */}
                        <div className='float_text_div'>
                            {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                   <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                        </div>
                    </div>
                </div>
                :
                search?.trim()?.length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>
                                {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                    <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                {/* <img src={errorData} className='' alt="" /> */}
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                      <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                      <p className='no_data_para'>There are no records to show you right <br /> now.</p> */}
                                </div>
                            </div>
                        </div>
            }
            </>

    };


    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between" style={{ marginBottom: '1rem' }}>
                <h1 className="heading fw_600"> Ads.txt </h1>
            </div>
            <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        onChange={handleTabChange}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="live" >Currently Live</Radio.Button>
                        <Radio.Button value="history">History</Radio.Button>
                    </Radio.Group>
                </div>

                {/* {tab === "history" && !initialLoad &&
                    <div className="form_content_block--group mb-0 w-auto">
                        <Input type='text' className='form_control basic md search_input w_table_search' placeholder="Search"
                            value={search}
                            onChange={(e) => {

                                if (e.target.value.trim().length === 0) {
                                    setLoading(true)
                                }

                                setSearch(e.target.value)
                            }}
                        />
                    </div>
                } */}
            </div>


            <div className="container_box--form-container border-0 p-0 mb-0" style={{ opacity: tab === "live" ? "1" : "0", display: tab === "live" ? "block" : "none" }}>
                <div className="container_box--width w-100">
                    <Row gutter={16}>
                        <Col span={24}>
                            <div className="container_box--form-container mb-0">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="block-category block_category_adjustment">
                                                <div className="form_content_block--group mb-0">
                                                    <div className="d_flex justify-content-between mb_16 align-items-start">
                                                        <div className='d-flex align-items-center' style={{ gap: '1.2rem' }}>
                                                            <h3 className='currently_live_text'>Currently Live</h3>
                                                            <span className='live_tag_design'>Live</span>
                                                        </div>
                                                        {!initialLoad &&
                                                            <span className='download_sample_text'
                                                                onClick={handleDownloadSampleFile}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M4.66675 6.66663L8.00008 9.99996L11.3334 6.66663" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 10V2" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                                Download Sample upload format
                                                            </span>
                                                        }
                                                    </div>
                                                    {!initialLoad &&
                                                        <div className="d_flex justify_content_between w_100 mb_10">
                                                            <div className="d_flex align-items-center justify_content_between w_100">
                                                                <div className="form_content_block--group mb-0">
                                                                    <Input
                                                                        type="text"
                                                                        className="form_control basic md search_input w_table_search"
                                                                        placeholder="Search"
                                                                        value={searchText}
                                                                        style={{ width: '40rem' }}
                                                                        onChange={e => setSearchText(e.target.value)}
                                                                    />
                                                                </div>

                                                                {/* <div className="custom_filter_design_d2">
                                                                <Dropdown ref={dropdownRef} show={show} onToggle={handleToggle} className="" autoClose={false}>
                                                                    <div className='position-relative hover_effec_hide_show_d2'>
                                                                        <Dropdown.Toggle id="dropdown-autoclose-false">
                                                                            <img src={filterIcon} className="img-fluid" alt="" /> Filter
                                                                            <div className="selected_filter_tag_d2">
                                                                                <div>3</div>
                                                                            </div>
                                                                        </Dropdown.Toggle>
                                                                        <div className="clear_filter_icon_d2" style={{ top: '0.3rem' }}>
                                                                            <button type="button"> <img src={HoverCloseIcon} alt="" />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <Dropdown.Menu>
                                                                        <div className="filter_inner_heading_d2">
                                                                            <p className="m-0">Status</p>
                                                                            <div className="radio_value_select_d2">
                                                                                <div className="radio_active_design_d2">
                                                                                    <input type="radio" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_radio_select_d2">
                                                                                        enabledd
                                                                                    </label>
                                                                                </div>
                                                                                <div className="radio_active_design_d2">
                                                                                    <input type="radio" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_radio_select_d2">
                                                                                        enabledd
                                                                                    </label>
                                                                                </div>
                                                                                <div className="radio_active_design_d2">
                                                                                    <input type="radio" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_radio_select_d2">
                                                                                        enabledd
                                                                                    </label>
                                                                                </div>
                                                                                <div className="radio_active_design_d2">
                                                                                    <input type="radio" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_radio_select_d2">
                                                                                        enabledd
                                                                                    </label>
                                                                                </div>
                                                                                <div className="radio_active_design_d2">
                                                                                    <input type="radio" name="one" id="two" />
                                                                                    <label htmlFor="" className="single_radio_select_d2">
                                                                                        disabled
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <hr />

                                                                            <p className="m-0">Zone Category</p>
                                                                            <div className="checkbox_value_select_d2">
                                                                                <div className="checkbox_active_design_d2">
                                                                                    <input type="checkbox" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_checkbox_select_d2">
                                                                                        OpenRTB
                                                                                    </label>
                                                                                </div>
                                                                                <div className="checkbox_active_design_d2">
                                                                                    <input type="checkbox" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_checkbox_select_d2">
                                                                                        Prebid
                                                                                    </label>
                                                                                </div>
                                                                                <div className="checkbox_active_design_d2">
                                                                                    <input type="checkbox" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_checkbox_select_d2">
                                                                                        VAST
                                                                                    </label>
                                                                                </div>
                                                                                <div className="checkbox_active_design_d2">
                                                                                    <input type="checkbox" name="one" id="one" />
                                                                                    <label htmlFor="" className="single_checkbox_select_d2">
                                                                                        GAM Tag
                                                                                    </label>
                                                                                </div>
                                                                                <div className="checkbox_active_design_d2">
                                                                                    <input type="checkbox" name="one" id="two" />
                                                                                    <label htmlFor="" className="single_checkbox_select_d2">
                                                                                        Player Tag
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <hr />

                                                                            <p className="m-0">ADCODE</p>
                                                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                                                              
                                                                            </div>
                                                                            <hr />
                                                                        </div>
                                                                        <div className="filter_bottom_btns_d2 text-end">
                                                                            <button className="reset" type='button' onClick={handleResetClick}>Reset</button>
                                                                            <button className="apply" type='button' onClick={handleApplyClick}>Apply</button>
                                                                        </div>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div> */}

                                                                <div className="custom_filter_design_d2" style={{ marginLeft: "10px" }}>
                                                                    <div className="export_btn_hover_d2">
                                                                        <Button className="export_btn_d2"
                                                                            onClick={handleExport}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <g clip-path="url(#clip0_11006_24214)">
                                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_11006_24214">
                                                                                            <rect width="14" height="14" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            }>
                                                                            Export
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                                {uploadLoader ?
                                                                    <button className='btn btn_primary w_fit_content --table_upload_btn' style={{ marginLeft: "10px", pointerEvents: "none" }}>
                                                                        <span style={{ width: "140px" }}>
                                                                            Processing...
                                                                        </span>
                                                                    </button>
                                                                    :
                                                                    <button className='btn btn_primary w_fit_content --table_upload_btn' style={{ marginLeft: "10px" }}>
                                                                        <input type='file'
                                                                            name="file004"
                                                                            id="file004"
                                                                            accept=".xlsx, .xls"
                                                                            onChange={onChangeMediakit}
                                                                        />
                                                                        <span>

                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                <path d="M8 3.33334V12.6667" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M3.33325 8H12.6666" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                            Upload new file
                                                                        </span>
                                                                    </button>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='table_content--box table_empty_screen_d2 user_sync_table_v2 no_data_screen_view no_data_screen_view_different_table'
                                                        ref={tableWrapperRef}
                                                    >
                                                        {loading && !initialLoad &&
                                                            <div className="table_new_loader_d2">
                                                                <img src={FullLoader} className="img-fluid" alt="" />
                                                            </div>
                                                        }

                                                        {initialLoad ?
                                                            <TableLoader />
                                                            :

                                                            <>
                                                                <Table
                                                                    columns={columns}
                                                                    dataSource={filteredDataSource}
                                                                    scroll={{ x: 'max-content', y: dataSource?.length === 0 ? '0px' : 'calc(100vh - 46.9rem' }}
                                                                    pagination={false}
                                                                    locale={locale}
                                                                    showSorterTooltip={false}

                                                                />
                                                                <div className='table_button_addmore'>
                                                                    <Button
                                                                        icon={
                                                                            <svg viewBox="64 64 896 896" focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path></svg>
                                                                        } className='add_more_btn_two' onClick={handleAddMore}>
                                                                        Add more
                                                                    </Button>
                                                                </div>
                                                                <div className='table_row_number_with_details'>
                                                                    <span className='line_count'>{tableSummary.total} lines </span>

                                                                    <ul className='p-0 m-0'>
                                                                        <li>
                                                                            Exhaustive: <strong>{tableSummary.tagCount.exhaustive}</strong>
                                                                        </li>
                                                                        <li>
                                                                            Top: <strong>{tableSummary.tagCount.top}</strong>
                                                                        </li>
                                                                        <li>
                                                                            Direct: <strong>{tableSummary.tagCount.direct}</strong>
                                                                        </li>
                                                                    </ul>

                                                                    <div className='enabled_disabled_text'>
                                                                        <span className='enabled_text --green'>
                                                                            <strong>{tableSummary.enabled}</strong> Enabled
                                                                        </span>

                                                                        <span className='enabled_text --red'>
                                                                            <strong>{tableSummary.disabled}</strong> Disabled
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="table_content--box no_data_screen_view  user_sync_table_v2 --history_new_table_cls"
                style={{ opacity: tab === "history" ? "1" : "0", display: tab === "history" ? "block" : "none" }}
            >


                {loading && !initialLoad &&
                    <div className="table_new_loader_d2">
                        <img src={FullLoader} className="img-fluid" alt="" />
                    </div>
                }

                {initialLoad ?
                    <div className='bg-white p-4' style={{ borderRadiau: '1.2rem', marginTop: '1rem', border: '0.1rem solid #e2e8f0' }}>
                        <TableLoader />
                    </ div>
                    :
                    <>

                        <Table
                            columns={columnsHistory}
                            dataSource={dataSourceHistory || []}
                            pagination={false}
                            onChange={handleTableChange}
                            showSorterTooltip={false}
                            locale={localeHistory}
                            scroll={{ x: 'max-content', y: 'calc(100vh - 28rem' }}
                        />


                        {dataSourceHistory.length > 0 &&
                            <Row className="custom_pagination--container">
                                <Col span={6}>
                                    <div className="form_content_block--group mb_0">
                                        <Select
                                            className='form_select basic sm no_search'
                                            value={page.pageSize}
                                            onChange={handlePageSizeChange}
                                            style={{ width: 80 }}
                                            showSearch={false}
                                            options={[
                                                { value: 10, label: 10 },
                                                { value: 20, label: 20 },
                                                { value: 50, label: 50 },
                                                { value: 100, label: 100 },
                                            ]} />
                                        <label className='custom_pagination--label'>
                                            items per page
                                        </label>
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <span className="custom_pagination--total-text">
                                        {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                    </span>
                                </Col>
                                <Col span={6}>
                                    <Pagination
                                        current={page.current}  // Pass individual props instead of spreading them
                                        pageSize={page.pageSize}
                                        total={page.total}
                                        onChange={handlePageChange}
                                        showSizeChanger={false}
                                        itemRender={itemRender}
                                        className="custom_pagination" />
                                </Col>
                            </Row>
                        }
                    </>
                }
            </div>
        </div>
    )
}

export default AdsTxtMobileOps
